// extracted by mini-css-extract-plugin
module.exports = {"Component":"RoomCard_Component__1eZPP"};